import { MessageSquare } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const NoChatSelected = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center h-full text-center text-muted">
      <MessageSquare size={120} absoluteStrokeWidth />
      <h2 className="text-xl font-semibold mt-4">{t('CHAT_PANEL.NO_CHAT_SELECTED_TITLE')}</h2>
      <p className="text-sm text-muted mt-2 max-w-xs">{t('CHAT_PANEL.NO_CHAT_SELECTED_DESCRIPTION')}</p>
    </div>
  );
};
